import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var GraduationCapSVG = function GraduationCapSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.6,11.56,17,7.14a3.44,3.44,0,0,0-2,0L2.42,11.56c-.54.19-.54.5,0,.69l13.29,4.66a.5.5,0,0,1,.3.64l-.36,1a.49.49,0,0,1-.64.3L8,16.38V20.5a2.59,2.59,0,0,0,.22.95S10,25,16,25s7.78-3.55,7.78-3.55A2.59,2.59,0,0,0,24,20.5V14.21l2-.7V21a1,1,0,0,0,2,0V12.81l1.6-.56C30.13,12.06,30.13,11.75,29.6,11.56ZM15.93,13c-.83,0-1.5-.45-1.5-1s.67-1,1.5-1,1.5.45,1.5,1S16.76,13,15.93,13Z"
  }));
};
GraduationCapSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(GraduationCapSVG);